<template>
  <a-modal v-model:visible="visible" title="温馨提示" :maskClosable="false" :closable="false">
    <div class="box">
      <div class="tip">
        检测到您已完成支付宝授权<br />
        <!-- 请联系客服协助您激活支付宝小程序<br /> -->
        <!-- 2. 您也可以在应用右上角点击【前往店铺后台】，去配置支付宝小程序 >>>立即前往 -->
      </div>
      <!-- <div class="kefuImg" style="text-align: center">
        <img src="https://static.zzbtool.com/static/dyorder/1688_duan/zfb.jpg" width="260" height="260" />
      </div> -->
    </div>
    <template #footer>
      <a-button type="primary" @click="openPage">使用教程</a-button>
      <a-button type="primary" danger @click="reload">关闭窗口</a-button>
    </template>
  </a-modal>
</template>
<script>
import aliUtil from "@/utils/check_ali_auth";
export default {
  data() {
    return {
      visible: false,

      // courseUrl: 'https://www.yuque.com/qiangzi-0veiu/ge9g4z/dfpcbn2irt604115?singleDoc#'
      courseUrl: "https://www.yuque.com/qiangzi-0veiu/ge9g4z/cu1bt6etzw37apmz?singleDoc",
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    reload() {
      aliUtil.SetLocalData();
    },
    openPage() {
      window.open(this.courseUrl);
    },
  },
};
</script>
<style scoped lang="less">
.box {
  .tip {
    font-size: 18px;
    margin-bottom: 1em;
  }
}
</style>
